import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Model from "../Model";
import {
    InputGroup,
    Label,
    SideCancelBtn,
    SubmitBtn,
} from "../Styles/InputStyles";
import { useSelector } from "react-redux";


const validationSchema = Yup.object({
    roomNumber: Yup.string()
        .matches(/^[0-9]+$/, "Room count must be a number")
        .min(1, "No Of Rooms must be at least 1")
        .max(2, "No Of Room number must be at most 50")
        .test(
            "is-between-1-and-25",
            "No Of Room must be between 1 and 50",
            (value) => {
                const number = parseInt(value, 10);
                return number >= 1 && number <= 50;
            }
        )
        .required("Room number is required"),
});

const AddRoomNumber = ({
    setRoomNumberModel,
    selectedData,
    addRoomNumberLoading,
    addRoomNumberMutate,
    propId,
    isFlat,
}) => {
    // const selectProperty = useSelector(
    //     (state) => state.SelectPropertyReducer.selectProperty
    // );
    // const propId = selectProperty.id;
    const initialValues = {
        roomNumber: "",

    };

    const handleAddSubmit = (values) => {
        addRoomNumberMutate({
            propId: propId,
            rooms: [
                isFlat
                    ? {
                        flatId: selectedData.id,
                        roomCount: Number(values.roomNumber),
                    }
                    : {
                        floorNumber: String(selectedData.floor),
                        roomCount: Number(values.roomNumber),
                    },
            ],
        });

    };

    return (
        <Model
            width={"w-full max-w-md"}
            setOpenModel={setRoomNumberModel}
            title="Add Room"
        >
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleAddSubmit}
            >
                {() => (
                    <Form>
                        <InputGroup>
                            <Label>Enter No. of Rooms</Label>
                            <Field
                                type="number"
                                name="roomNumber"
                                className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="Enter Room No."
                            />
                            <ErrorMessage
                                name="roomNumber"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                            />
                            <span className="items-center text-sm text-gray-400">No Of Room must be less than or equal to 50</span>
                        </InputGroup>

                        <div className="w-full flex justify-between space-x-6 my-4">
                            <SideCancelBtn onClick={() => setRoomNumberModel(false)}>
                                Cancel
                            </SideCancelBtn>
                            <SubmitBtn type="submit" disabled={addRoomNumberLoading} className="border border-primary-color bg-white text-primary-color hover:bg-primary-color hover:text-white">
                                {" "}
                                {addRoomNumberLoading ? "Submitting..." : "Submit"}
                            </SubmitBtn>
                        </div>
                    </Form>
                )}
            </Formik>
        </Model>
    );
};

export default AddRoomNumber;